function serializeSong(song) {
  if(!song) return ''
  return JSON.stringify(song)
}

function deserializeSong(json) {
  if(!json) return null
  return JSON.parse(json)
}

export { serializeSong, deserializeSong }
